import * as angular from "angular";

angular
  .module('bringoz.admin.routes')
  .constant('Routes_PN', {
    database: 'routes',
    isBranchEntity: true,
    events: {
      onCreate: 'RoutesCreated',
      onChange: 'RoutesChanged'
    }
  });
